/**
 * Pauses point cloud LOD updates during zoom-to-location fly tweens.
 * Restores the viewer freeze state that existed before the tween started.
 */
export function attachFreezeDuringTween (viewer, tween, onComplete) {
	let ended = false;
	const previousFreeze = viewer.getFreeze();
	viewer.setFreeze(true);

	const endFreeze = () => {
		if (ended) {
			return;
		}
		ended = true;
		viewer.setFreeze(previousFreeze);
	};

	tween.onStop(endFreeze);
	tween.onComplete(() => {
		endFreeze();
		if (onComplete) {
			onComplete();
		}
	});
}
